import TagManager from 'react-gtm-module';
import { gtmId } from '../../config';

const initializeGTM = () => {
  const tagManagerArgs = {
    gtmId: gtmId,
  }
  TagManager.initialize(tagManagerArgs);
};

const pushToDataLayer = (event, data = {}) => {
  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data,
    },
  });
};

export { initializeGTM, pushToDataLayer };


// WEBPACK FOOTER //
// ./src/helpers/analytics/index.js